import { Pipe, PipeTransform } from '@angular/core';

import { UiLocaleService } from '../services/ui-locale.service';
import { TranslationBundle } from '../content-page/common/skill-learning/models/translation-bundle.model';

@Pipe({
  name: 'standardContent',
  pure: false
})
export class StandardContentTranslationPipe implements PipeTransform {

  constructor(private uiLocaleService: UiLocaleService) {
  }

  transform(source: string, translation?: TranslationBundle): string {
    return this.uiLocaleService.resolveContent(source, translation);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/pipes/standard-content-translation.pipe.ts